<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
<div >
  <div class="row mt-3">
    <div class="col-10 mb-3">
      <h2 class="title-list">List of Devices</h2>
    </div>
    <div class="col-1 text-end">
      <button *ngIf="permissionsService.editPermission && permissionsService.readPermission" class="btn btn-secondary"
        (click)="exportListDevicesToExcel()">
        <i class="bi bi-file-earmark-excel"></i>
      </button>
    </div>

    <div class="col-1 text-left">
      <button class="btn btn-secondary" (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)">
        <i class="bi bi-archive"></i>
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">
          <i class="bi bi-search"></i>
        </span>
        <input type="text" class="form-control input-label" placeholder="Search" [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()" />
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    
    <div>
      <app-double-scroll>
      <table class="table table-striped mb-0">
        <caption class="d-none">
          List of devices and their details
        </caption>
        <thead class="head-table" style="white-space: nowrap;">
          <tr>
            <th class="px-4 py-3 align-middle">Primary</th>
            <th class="px-4 py-3 align-middle">Customer Name</th>
            <th class="px-4 py-3 align-middle">Plan</th>
            <th class="px-4 py-3 align-middle">Status</th>
            <th class="px-4 py-3 align-middle">ICCID</th>
            <th class="px-4 py-3 align-middle">IMEI</th>
            <th class="px-4 py-3 align-middle">Username</th>
            <th class="px-4 py-3 align-middle">Username 2</th>
            <th class="px-4 py-3 align-middle">Usage MB</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="
              let device of devices
                | search : textoBusqueda : camposBusqueda
                | slice : (paginationService.currentPage - 1) * 10 : paginationService.currentPage * 10
            ">
            <td class="px-4 py-3 align-middle">
              <!-- Puedes ajustar el checkbox según tus necesidades -->
              <input type="checkbox" [(ngModel)]="device.devPrimary" disabled />
            </td>
            <td class="px-4 py-3 align-middle" *ngIf="permissionsService.editPermission">
              <a href="javascript:void(0)" (click)="redirectToCustomer(device)" class="green-link"
                title="{{ device.userNames }}">
                {{ device.userNames }}
              </a>
            </td>
            <td class="px-4 py-3 align-middle" *ngIf="!permissionsService.editPermission"
              title="{{ device.username2 }}">
              {{ device.username2 }}
            </td>
            <td class="px-4 py-3 align-middle" title="{{ device.planName }}">{{ device.planName }}</td>
            <td class="px-4 py-3 align-middle">
              <div *ngIf="device.deviceStatus === 0 || device.deviceStatus === 1" class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [(ngModel)]="device.deviceStatus"
                  id="flexSwitchCheckDefault" [checked]="device.deviceStatus === 1" disabled data-bs-toggle="modal"
                  data-bs-target="#modalSwitch" />
              </div>
              <div *ngIf="device.deviceStatus === 2">
                <span class="archived">Archived</span>
              </div>
            </td>
            <td class="px-4 py-3 align-middle" *ngIf="permissionsService.editPermission">
              <a href="javascript:void(0)" (click)="redirectToDevice(device)" class="green-link"
                title="{{ device.iccid }}">
                {{ device.iccid }}
              </a>
            </td>
            <td class="px-4 py-3 align-middle" *ngIf="!permissionsService.editPermission" title="{{ device.iccid }}">
              {{ device.iccid }}
            </td>
            <td class="px-4 py-3 align-middle" title="{{ device.imei }}">{{ device.imei }}</td>
            <td class="px-4 py-3 align-middle" title="{{ device.deviceName }}">{{ device.deviceName }}</td>
            <td class="px-4 py-3 align-middle" title="{{ device.username2 }}">{{ device.username2 }}</td>
            <td class="px-4 py-3 align-middle" title="{{ device.consumption }}">{{ device.consumption }}</td>
          </tr>
        </tbody>
      </table>
    </app-double-scroll>
    <div class="row d-flex align-items-center justify-content-between">
      <div class="col-2">
        <label>
          Showing {{ (paginationService.currentPage - 1) * paginationService.recordsPerPage + 1 }} 
          to {{ paginationService.currentPage * paginationService.recordsPerPage < filteredDevices.length ? paginationService.currentPage * paginationService.recordsPerPage : filteredDevices.length }} 
          out of {{ filteredDevices.length }} entries
        </label>
      </div>
      <div class="col-7">
        <div class="col-12 pagination text-left">
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationService.currentPage === 1">
                <a class="page-link" href="javascript:void(0)" tabindex="-1" aria-disabled="true" (click)="previousPage()">
                  <i class="bi bi-chevron-left"></i>
                </a>
              </li>
              <ng-container *ngFor="let page of pages">
                <li class="page-item" [class.active]="page === paginationService.currentPage">
                  <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
                </li>
              </ng-container>
              <li class="page-item" [class.disabled]="paginationService.currentPage === paginationService.totalPages">
                <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                  <i class="bi bi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
</div>
